import request from '@/utils/request'
import { detectiveUrl } from '@/env'

export function getVideo(state) {
    return request({
        url: `${detectiveUrl()}/api/video/list`,
        method: 'post',
        params: state.params,
        data: state.data
    })
}

export function addVideo(state) {
    return request({
        url: `${detectiveUrl()}/api/video/add`,
        method: 'post',
        data: state
    })
}

export function editVideo(state) {
    return request({
        url: `${detectiveUrl()}/api/video/edit/${state.id}`,
        method: 'put',
        data: state
    })
}

export function editVideoStatus(state) {
    return request({
        url: `${detectiveUrl()}/api/video/edit/${state.id}`,
        method: 'put',
        data: {
            status: state.status
        }
    })
}

export function deleteVideo(state) {
    return request({
        url: `${detectiveUrl()}/api/video/delete/${state}`,
        method: 'delete'
    })
}
